import React, { useState, useEffect } from "react";
import "../../styleSheet/main/components/TODO/historyForTODO/historyForTODO.css";
import httpClient from "../../services/httpClient";

const HistoryForTODO = ({ userId }) => {
  const [completedTasks, setCompletedTasks] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!userId) {
      console.error("User ID is undefined. Cannot fetch task history.");
      setIsLoading(false);
      return;
    }

    const fetchTaskHistory = async () => {
      try {
        const response = await httpClient.get(
          `/ToDoTasks/assigned-by-me/to-user/${userId}/history`,
          { withAuth: true }
        );

        // Map API response to expected format
        const mappedTasks = response.data.map((task) => ({
          ...task,
          text: task.title || task.text, // Use title from API
          date: task.completedAt || task.date, // Use completedAt from API
        }));

        console.log("History tasks:", mappedTasks);
        setCompletedTasks(mappedTasks);
      } catch (err) {
        console.error("Error fetching task history:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTaskHistory();
  }, [userId]);

  if (isLoading) {
    return <p>Ładowanie historii zadań...</p>;
  }

  return (
    <div className="history-overlay">
      <div className="history-content">
        <p>Historia zadań TODO</p>
        <div className="completed-tasks">
          {completedTasks.length === 0 ? (
            <div className="lack">Brak zadań w historii.</div>
          ) : (
            completedTasks.map((task, index) => (
              <div key={index} className="completed-task">
                <span>
                  <strong>Zadanie :</strong> {task.text}
                </span>
                <span>
                  <strong>Ukończone :</strong>{" "}
                  {new Date(task.date).toLocaleDateString("pl-PL")}
                </span>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default HistoryForTODO;
